import React from "react";
import TextInput from "./TextInput";

const EmailInput = ({ id = "email", label = "Email", value, errorText = null, onChange, disabled = false, mt = 0, mb = 0 }) => {

    return (
        <TextInput
            id={id}
            name={id}
            label={label}
            type="email"
            onChange={onChange}
            errorText={errorText}
            value={value}
            disabled={disabled}
            mt={mt}
            mb={mb}
        />
    );
};

export default EmailInput;
